import { render, staticRenderFns } from "./Karin-search.vue?vue&type=template&id=3d4e202f&scoped=true"
import script from "./Karin-search.vue?vue&type=script&lang=js"
export * from "./Karin-search.vue?vue&type=script&lang=js"
import style0 from "./Karin-search.vue?vue&type=style&index=0&id=3d4e202f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e202f",
  null
  
)

export default component.exports